import { Reveal } from "../components/Reveal";

export default function WhyAiSection() {
  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
      <div className="grid md:grid-cols-12 gap-10">
        <Reveal className="md:col-span-5">
          <h2 className="font-display text-4xl md:text-6xl tracking-tighter font-medium leading-[0.98]">
            Why AI-augmented beats a standard VA.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-6 md:col-start-7 self-end">
          <p className="text-lg md:text-xl text-neutral-500 leading-relaxed">
            A plain real estate virtual assistant processes what you send them. A Quexify operator builds real automation into the work: pulling key dates straight off your contract, sending status updates the moment a file moves, flagging missing documents before they threaten a closing date.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
